var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.spanning)?_c('div',{staticClass:"spanning-wrap"},[_c('a-spin',{staticClass:"spin-item",attrs:{"spinning":_vm.spinning}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }